"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingUpdate = void 0;
const ee_proto_interfaces_1 = require("ee-proto-interfaces");
const class_validator_proxy_1 = require("./class-validator-proxy");
const swagger_proxy_1 = require("./swagger-proxy");
class PricingUpdate {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "The pricing model to apply",
        type: Object,
    }),
    (0, class_validator_proxy_1.IsObject)(),
    __metadata("design:type", Object)
], PricingUpdate.prototype, "model", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Optional description of the pricing change",
        example: "Updated rates for peak hours",
        type: String,
        required: false,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], PricingUpdate.prototype, "changeDescription", void 0);
exports.PricingUpdate = PricingUpdate;
